<template>
<el-tabs v-model="card_index">
  <el-tab-pane label="总览" name="ThirdPartyCompanyProject">
    <ThirdPartyCompanyProject v-if="card_index==='ThirdPartyCompanyProject'" :urge_type="3" />
  </el-tab-pane>
  <el-tab-pane label="结算列表" name="ThirdPartyCompanyProjectMonth">
    <ThirdPartyCompanyProjectMonth v-if="card_index==='ThirdPartyCompanyProjectMonth'" :urge_type="3" />
  </el-tab-pane>
</el-tabs>
</template>

<script>
import ThirdPartyCompanyProject from "./ThirdPartyCompanyProject";
import ThirdPartyCompanyProjectMonth from "./ThirdPartyCompanyProjectMonth";
export default {
  name: "ThirdPartyCompanyProjectLayout",
  components: {ThirdPartyCompanyProjectMonth, ThirdPartyCompanyProject},
  data(){
    return{
      card_index:"ThirdPartyCompanyProject"
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty/ThirdPartyCompanyProjectLayout.vue